<div class="w-full" *ngIf="data && chartData && chartOptions && !hasEmptyData()">
  <!-- Chart Title -->
  <div *ngIf="config.title" class="mb-4">
    <h3 class="text-lg font-semibold text-night-darker">{{ config.title }}</h3>
  </div>

  <!-- Chart Canvas -->
  <div
    class="relative flex justify-center items-center min-h-[200px] md:min-h-[250px]"
    [style.height.px]="config.height || 300"
    [style.width.px]="config.width">
    <canvas
      baseChart
      class="w-full h-full max-w-full max-h-full"
      [data]="chartData"
      [options]="chartOptions"
      type="pie">
    </canvas>
  </div>
</div>

<!-- No Data State -->
<div
  *ngIf="!data || !data.datasets || data.datasets.length === 0 || hasEmptyData()"
  class="flex items-center justify-center py-12">
  <div class="text-center">
    <div class="text-smoke-darker text-sm">No data available to display</div>
  </div>
</div>
